import { render, staticRenderFns } from "./SmsMultiplePhoneAlertModal.vue?vue&type=template&id=fb52c73a&scoped=true"
import script from "./SmsMultiplePhoneAlertModal.vue?vue&type=script&lang=js"
export * from "./SmsMultiplePhoneAlertModal.vue?vue&type=script&lang=js"
import style0 from "./SmsMultiplePhoneAlertModal.vue?vue&type=style&index=0&id=fb52c73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb52c73a",
  null
  
)

export default component.exports